import { apiRequest } from './httpClient';

export async function cancelAnalysis() {
    return apiRequest('/cancel-analysis', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    });
}

export async function getAnalysisStatus() {
    return apiRequest('/analysis-status');
}

export async function getTableSize(selectedTable) {
    return apiRequest(`/table-size/${selectedTable}`);
}

export async function getTopDestinations(selectedTable, limit = 5) {
    return apiRequest(`/top-destinations/${selectedTable}?limit=${limit}`);
}
